import { type SanityProductFragment } from '@data/sanity/queries/types/product'

import Button, { ButtonSize, ButtonVariant } from '@components/buttons/button'

interface BundleSlotSelectionProps {
  label?: string
  products: SanityProductFragment[]
  selectedProductId: number
  onClick(product: SanityProductFragment): void
}

const BundleSlotSelection = ({
  label,
  products,
  selectedProductId,
  onClick,
}: BundleSlotSelectionProps) => (
  <div className="flex items-center justify-between mb-4">
    {label && (
      <p className="mr-12 text-xs font-semibold uppercase tracking-wider">
        {label}
      </p>
    )}

    <div className="flex flex-wrap items-center justify-end -mt-2">
      {products.map((product) => (
        <Button
          key={product.productID}
          variant={ButtonVariant.OUTLINED}
          size={ButtonSize.SMALL}
          isActive={selectedProductId == product.productID}
          onClick={() => onClick(product)}
          className="mt-2 ml-2"
        >
          {product.title}
        </Button>
      ))}
    </div>
  </div>
)

export default BundleSlotSelection
